"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkData = exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var gridCalculations_1 = require("../../core/galleriesCommon/gridCalculations");
exports.props = withCompInfo_1.withCompInfo(['skin', 'compProps'], function (_a, carmiData) {
    var skin = _a.skin, compProps = _a.compProps;
    var extraRows = compProps.incRows, rows = compProps.maxRows, columns = compProps.numCols, showMoreLabel = compProps.showMoreLabel, galleryImageOnClickAction = compProps.galleryImageOnClickAction, imageMode = compProps.imageMode;
    return {
        skin: skin,
        extraRows: extraRows,
        rows: rows,
        columns: columns,
        items: carmiData.itemsProps,
        showMoreLabel: showMoreLabel || '',
        imageOnClickAction: galleryImageOnClickAction,
        isFitMode: imageMode === 'flexibleWidthFixed' && skin !== 'MatrixGalleryCircleSkin',
    };
});
var MIN_HEIGHT = 70;
var showMoreHeightMap = {
    MatrixGalleryDefaultSkin: 25,
    MatrixGalleryLiftedShadow: 25,
    MatrixGallerySloopy: 25,
    MatrixGalleryCircleSkin: 40,
    MatrixGalleryTextSlideUpSkin: 25,
    MatrixGalleryIronSkin: 40,
    MatrixGalleryScotchTapeSkin: 50,
    MatrixGalleryTextOnCenterSkin: 25,
    MatrixGalleryTransparentSkin: 25,
    TextBottomCustomHeightSkin: 25,
    PolaroidCustomHeightSkin: 25,
    MatrixGallerySeparateTextBoxSkin: 40,
    MatrixGalleryPolaroidSkin: 25,
    MatrixGalleryTextBelowSkin: 25,
    BlogMatrixGallery: 25,
    MatrixGalleryVintage: 25,
    PolaroidMatrixGallery: 0,
};
exports.css = withCompInfo_1.withCompInfo(['compProps', 'compLayout', 'skin'], function (_a) {
    var compProps = _a.compProps, compLayout = _a.compLayout, skin = _a.skin;
    var _b = compLayout.height, height = _b === void 0 ? MIN_HEIGHT : _b;
    var margin = compProps.margin, rows = compProps.maxRows, columns = compProps.numCols, _c = compProps.alignText, alignText = _c === void 0 ? 'left' : _c, itemHeight = compProps.itemHeight;
    var showMoreContainerHeight = showMoreHeightMap[skin];
    var rowHeight = itemHeight || gridCalculations_1.getRowHeight(height, margin, rows, showMoreContainerHeight);
    return {
        height: 'auto',
        '--number-of-columns': columns,
        '--spacing': margin + "px",
        '--row-height': rowHeight + "px",
        '--text-align': alignText,
        '--show-more-container-height': showMoreContainerHeight + "px",
    };
});
exports.sdkData = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    return {
        imageDisplayMode: 'fill',
        dataId: compData.id,
    };
});
//# sourceMappingURL=MatrixGallery.js.map